import { render, staticRenderFns } from "./MarkerDendrogram.vue?vue&type=template&id=57f66da3&lang=html"
import script from "./MarkerDendrogram.vue?vue&type=script&lang=js"
export * from "./MarkerDendrogram.vue?vue&type=script&lang=js"
import style0 from "./MarkerDendrogram.vue?vue&type=style&index=0&id=57f66da3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports